import React from 'react';
import './NotificationBadge.css';

/**
 * NotificationBadge — small round red count badge, reusable across the app.
 *
 * Props:
 *   count      – number; the badge renders nothing when count <= 0.
 *   max        – cap before showing "<max>+" (default 99 → "99+").
 *   className  – extra classes for positioning (e.g. 'notif-badge-corner').
 *   title      – optional tooltip.
 *
 * Always a circle (fixed width = height, border-radius 50%). Values over
 * `max` collapse to "<max>+" so it never grows into an oval.
 */
export default function NotificationBadge({ count = 0, max = 99, className = '', title }) {
  const n = Number(count) || 0;
  if (n <= 0) return null;
  const label = n > max ? `${max}+` : String(n);
  return (
    <span
      className={`notif-badge${className ? ` ${className}` : ''}`}
      title={title != null ? title : `${n}`}
      aria-label={`${n} pending`}
    >
      {label}
    </span>
  );
}
